<ng-container *renderIf="item.role">
  <ng-container *ngIf="!item.hidden">
    <span class="navigation-section-text" [translate]="item.translate">{{ item.title }}</span>
    <!-- More icon in collapsed menu -->
    <span [data-feather]="'more-horizontal'"></span>
  </ng-container>
</ng-container>